import React, { useCallback, useContext } from "react";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import right from "bodycodi/cmap/app/img/icon-right-gray.png";
import icon_main_flag from "bodycodi/cmap/app/img/icon-main-flag.png";
import "bodycodi/cmap/app/css/common/centerChoosePop.css";
import { useDispatch } from "react-redux";
import { AppDispatch } from "bodycodi/cmap/app/redux/store";
import { setParterBranch } from "bodycodi/cmap/app/redux/slices/partnerSlice";

type ChooseCenterProp = {
  partnerList: any[];
  seqPartner: number;
  seqPartnerBranch: number;
};

const PartnerListPop = ({ partnerList = [], seqPartner, seqPartnerBranch }: ChooseCenterProp) => {
  const dispatchRedux = useDispatch<AppDispatch>();
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const addCenter = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_LIST_POP", open: { centerListPop: false } });
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_MNGT_POP", open: { centerMngtPop: true } });
  }, []);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_LIST_POP", open: { centerListPop: false } });
  };

  const handleClickPartner = useCallback(
    (d) => {
      dispatchRedux(
        setParterBranch({
          seqPartner: d.seqPartner,
          seqPartnerBranch: d.seqPartnerBranch,
          seqPartnerCoach: d.seqPartnerCoach,
          partnerName: d.partnerName,
          partnerBranchName: d.partnerBranchName,
        })
      );
      dispatch({ type: "POP_UP_OPEN", id: "CENTER_LIST_POP", open: { centerListPop: false } });
      dispatch({
        type: "UPDATE",
        data: {
          toast: true,
          toastText: `<span>${d.partnerName}${
            d.partnerBranchName ? ` ${d.partnerBranchName}` : ""
          }로 변경되었어요.</span>`,
        },
      });
    },
    [partnerList]
  );

  return (
    <React.Fragment>
      <Drawer
        anchor="bottom"
        open={state.centerListPop}
        onClose={handleClose}
        className="picker-pop auto"
      >
        <PickerHeader title="센터 선택" onClose={handleClose} />
        <div className="center-choose-pop-body">
          <div className="center-list-wrap center-list-wrap1">
            {partnerList.map((d: any) => (
              <div
                key={`${d.seqPartner}${d.seqPartnerBranch}`}
                onClick={() => handleClickPartner(d)}
                className={
                  "center-choose-pop-list" +
                  (d.seqPartner === seqPartner && d.seqPartnerBranch === seqPartnerBranch
                    ? " active1"
                    : "")
                }
              >
                <div className="title">
                  {d.mainPartnerFlag === 1 && <img className="icon" src={icon_main_flag} />}
                  {d.partnerName} {d.partnerBranchName}
                </div>
              </div>
            ))}
          </div>
          <div className="center-choose-add-center-wrap">
            <div className="center-choose-add-center" onClick={addCenter}>
              <img className="center" src={icon_main_flag} alt="" />
              <div className="text">
                <div className="blue">
                  주 연동센터
                  <span className="gray">
                    <span className="regular"> 설정하기</span>
                  </span>
                </div>
              </div>
              <img className="left" src={right} alt="" />
            </div>
          </div>
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default PartnerListPop;
